


export type TimeBookingsSort = 'From';

export const TimeBookingsSort = {
    From: 'From' as TimeBookingsSort
};

